import { createSelector, createSlice } from "@reduxjs/toolkit";
import type { RootState } from "Types";
import { isActionInProgressSelector } from "./utils/loader/progress.slice";
import { sessionTokenFailedExceptionBaseMessage } from "./utils";
import type { AppError, AppState } from "./app.types";

const initialState: AppState = {
  status: "idle",
  error: null,
  sessionTokenError: null,
};

export const appSlice = createSlice({
  name: "app",
  initialState,
  reducers: {
    clear: () => {
      return initialState;
    },
    clearAppState: () => {
      return initialState;
    },
    setSessionTokenError: (state, action) => {
      state.sessionTokenError = action.payload;
    },
    clearSessionTokenError: (state) => {
      state.sessionTokenError = initialState.sessionTokenError;
    },
  },
});

export const {
  clear,
  clearAppState,
  setSessionTokenError,
  clearSessionTokenError,
} = appSlice.actions;

export const selectAppState = (state: RootState): AppState => state.app;

export const isFetchConfigInProgressSelector = (state: RootState) =>
  isActionInProgressSelector(state, "fetchConfig");

export const hasSessionTokenErrorSelector = createSelector(
  [selectAppState],
  (appState) =>
    Boolean(
      (appState.sessionTokenError as AppError)?.customMessage?.includes(
        sessionTokenFailedExceptionBaseMessage,
      ),
    ),
);

export default appSlice.reducer;
